export { default } from "./AgeGate";
export type { AgeGateProps } from "./types";
